import styles from "./PresentersBar.module.scss";

const useButtons = true;

export default function PresentersBar() {
  if (useButtons) return <PresentersBarButton />;
  return <PresentersBarImg />;
}
function PresentersBarButton() {
  return (
    <div className={styles.presentersBar}>
      <section>
        <button
          onClick={() => {
            window.open("https://www.ucalgary.ca/", "_blank");
          }}
          className={styles.buttonStyle}
        >
          <img
            src="logos/uofc-logo.svg"
            width="auto"
            height="40px"
            alt="Presented by University of Calgary"
          />
        </button>
        <button
          onClick={() => {
            window.open("https://godinos.com/index.aspx", "_blank");
          }}
          className={styles.buttonStyle}
        >
          <img
            src="logos/dinos.svg"
            width="auto"
            height="40px"
            alt="Presented by The Dinos"
          />
        </button>
        <button
          onClick={() => {
            window.open("https://en.usports.ca/landing/index", "_blank");
          }}
          className={styles.buttonStyle}
        >
          <img
            src="logos/u-sports-logo.svg"
            width="auto"
            height="56px"
            alt="Presented by U Sports"
          />
        </button>
        <button
          onClick={() => {
            window.open("https://en.usports.ca/championships/2025-26/2025-26_MBB/index", "_blank");
          }}
          className={styles.buttonStyle}
        >
          <img
            src="logos/final8-logo.png"
            width="auto"
            height="80px"
            alt="Presented by Final 8"
          />
        </button>
      </section>
    </div>
  );
}
function PresentersBarImg() {
  return (
    <div className={styles.presentersBar}>
      <section>
        <img
          src="logos/uofc-logo.svg"
          width="auto"
          height="40px"
          alt="Presented by University of Calgary"
        />
        <img
          src="logos/dinos.svg"
          width="auto"
          height="40px"
          alt="Presented by The Dinos"
        />
        <img
          src="logos/u-sports-logo.svg"
          width="auto"
          height="56px"
          alt="Presented by U Sports"
        />
        <img
          src="logos/final8-logo.png"
          width="auto"
          height="80px"
          alt="Presented by Final 8"
        />
      </section>
    </div>
  );
}
